import install from './install';
var actionStack = [];
var isInstalled = false;
var uninstall;
export function getCurrentAction() {
    return actionStack.length ? actionStack[actionStack.length - 1] : null;
}
export function promiseMiddleware(next, action, actionType, args, actionContext) {
    if (!isInstalled) {
        uninstall = install();
        isInstalled = true;
    }
    try {
        actionStack.push(actionType);
        return next(action, actionType, args, actionContext);
    }
    finally {
        actionStack.pop();
        if (!actionStack.length) {
            uninstall();
            isInstalled = false;
        }
    }
}
